import Vue from 'vue'
import Vuex from 'vuex'
import { state, mutations, actions, getters } from './entities';
// import facility from './modules/facilities'
// import rosting from './modules/rosting'
// import vendor from './modules/vendors'
// import rostering from './modules/rostering/rostering'
import login from './modules/login'
// import team from './modules/team'
import driver from './modules/driver'
// import shift from './modules/shift'
// import process from './modules/process'
import vehicle from './modules/vehicle'
// import roster from './modules/roster'
// import selfRostering from './modules/selfRostering'
// import raiseAdhocReq from './modules/raiseAdhocReq'
// import user from './modules/user'
import vehicleCategory from './modules/vehicleCategory'
// import vendorUser from './modules/vendorUser'
// import userRole from './modules/userRole'

// import vendorTripSheet from './modules/vendorTripSheet';
// import metaData from "./modules/metaData"
// import activeEmp from "./modules/activeEmp"
import profile from "./modules/profile";
import vehicleType from "./modules/vehicleType";
// import costComponent from './modules/costComponent';
// import billing from './modules/billing';
import sosList from './modules/sosList';
// import routingSetting from './modules/routingSetting';
import dashBoard from './modules/dashBoard';
// import vendorBilling from './modules/vendorBilling';
// import tripSetting from './modules/tripSetting';
// import seatBooking from './modules/seatBooking';
// import reports from './modules/reports';
import mapStore from "./modules/mapStore";
import device from "./modules/device";
import metadata from "./modules/metadata";
import reportConfig from "./modules/reportConfig"
import configuration from './modules/configuration';
import sensor from "./modules/sensor";
import settings from "./modules/settings";
import userManagement from "./modules/userManagement";
import vehicleUserMap from "./modules/vehicleUserMap";
import reports from "./modules/reports";
import dynamicReport from "./modules/dynamicReport";
import tenantSettings from "./modules/tenantSettings";
import deviceMonitoring from "./modules/DeviceMonitoring";
import iotExposer from "./modules/iotExposer";
import reportMaster from "./modules/reportMaster";

/* OIDC Store */
// import { oidcSettings } from '@/config/oidc'
// import { vuexOidcCreateStoreModule } from 'vuex-oidc'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    // facility,
    // team,
    // vendor,
    // rostering,
    login,
    driver,
    // shift,
    // process,
    vehicle,
    // roster,
    // selfRostering,
    // oidcStore: vuexOidcCreateStoreModule(oidcSettings, { namespaced: true }),
    // raiseAdhocReq,
    // user,
    vehicleCategory,
    // vendorUser,
    // vendorTripSheet,
    // metaData,
    // activeEmp,
    profile,
    vehicleType,
    // userRole,
    // costComponent,
    // billing,
    sosList,
    // routingSetting,
    dashBoard,
    // vendorBilling,
    // tripSetting,
    // seatBooking,
    // reports,
    mapStore,
    device,
    metadata,
    reportConfig,
    configuration,
    sensor,
    settings,
    userManagement,
    vehicleUserMap,
    reports,
    dynamicReport,
    tenantSettings,
    deviceMonitoring,
    iotExposer,
    reportMaster
  },
  state,
  actions,
  mutations,
  getters
})